import styled from 'styled-components'

export {
  TooltipContainer,
  TooltipOverlapHint,
  PopoverContainer,
  PopoverHeader,
  PopoverCloseButton,
  PopoverList,
  PopoverItem,
} from '../../molecules/MapTooltip/MapTooltip.styles'

export const VectorTileMapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const MapWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-size: 12px;
  color: ${({ theme }) => theme.colors?.text?.secondary || '#6b6b6b'};
`

export const ErrorOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-size: 12px;
  color: #ff3b30;
  text-align: center;
  padding: 16px;
`
